<template>
  <div class="date-range-filter">
    <span class="date-range-filter__label">{{ label }}</span>
    <div class="date-range-filter__inputs">
      <input type="date" class="form-control" :value="from" :max="to || null"
             :aria-label="label + ' — de'"
             @change="$emit('update:from', $event.target.value)">
      <span class="date-range-filter__sep">até</span>
      <input type="date" class="form-control" :value="to" :min="from || null"
             :aria-label="label + ' — até'"
             @change="$emit('update:to', $event.target.value)">
    </div>
  </div>
</template>

<script>
/**
 * Intervalo de datas de filtro: dois <input type="date"> (`yyyy-MM-dd`) com
 * `.sync` em `from` e `to`. Qualquer ponta pode ficar vazia; a regra do que
 * "encosta" no intervalo fica em listFilters.js.
 */
export default {
  name: 'date-range-filter',
  props: {
    label: { type: String, required: true },
    from: { type: String, default: '' },
    to: { type: String, default: '' },
  },
};
</script>

<style scoped>
.date-range-filter__label { display: block; margin-bottom: 4px; font-size: 12px; color: #4e5560; }
.date-range-filter__inputs { display: flex; align-items: center; gap: 6px; }
.date-range-filter__inputs .form-control { width: 150px; height: 34px; font-size: 12px; }
.date-range-filter__sep { font-size: 12px; color: #9ca0a7; }
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/default/dateRangeFilter.vue